/* eslint-disable @typescript-eslint/no-dynamic-delete */
import moment from 'moment';

import useUserStore from '../../../../../store/userStore/userStore';
import {OPKey} from '../constants/orgProfileKeyLabel';

export const filterCompanyDetails: (companyDetail: any) => any = (
  companyDetail
) => {
  const userId = useUserStore.getState().userDetails._id;

  delete companyDetail[OPKey.BUSINESS_EMAIL];
  delete companyDetail._id;
  delete companyDetail.__v;
  delete companyDetail.pbiUrls;
  companyDetail.baseLineYear = companyDetail.baseLineYear
    ? moment(companyDetail.baseLineYear).year().toString()
    : '';

  companyDetail.targetYear = companyDetail.targetYear
    ? moment(companyDetail.targetYear).year().toString()
    : '';

  companyDetail.incorporationYear = companyDetail.incorporationYear
    ? moment(companyDetail.incorporationYear).year()
    : 0;

  companyDetail.createdBy = companyDetail?.createdBy ?? userId;
  companyDetail.updatedBy = userId;

  return companyDetail;
};
